import { render, staticRenderFns } from "./TeamCoordinator.vue?vue&type=template&id=57d70290&scoped=true&"
import script from "./TeamCoordinator.vue?vue&type=script&lang=js&"
export * from "./TeamCoordinator.vue?vue&type=script&lang=js&"
import style0 from "./TeamCoordinator.vue?vue&type=style&index=0&id=57d70290&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d70290",
  null
  
)

export default component.exports